import { useState } from 'react';

type UseModalReturn<T = any> = {
  isShowing: boolean;
  text: string;
  toggle: () => void;
  data: T;
  open: (msg?: string) => void;
  close: () => void;
  openWithData: <T = any>(data?: T | undefined) => void;
};

function useModal<T = any>(): UseModalReturn<T> {
  const [text, setText] = useState('');
  const [data, setData] = useState<any | null>(null);
  const [isShowing, setIsShowing] = useState(false);

  const toggle = () => setIsShowing(!isShowing);

  const open = (msg = '') => {
    setIsShowing(true);
    if (msg) setText(msg);
  };

  function openWithData<T = any>(data?: T) {
    setIsShowing(true);
    if (data) setData(data);
  }

  const close = () => {
    setIsShowing(false);
    setText('');
    setData(null);
  };

  return {
    isShowing,
    text,
    toggle,
    data,
    open,
    close,
    openWithData,
  };
}

export default useModal;
